import { createFileRoute } from "@tanstack/react-router";
import { KalkulatorMarzyPage } from "@/features/strateg-cenowy/margin-calculator/components/KalkulatorMarzyPage";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/strateg-cenowy/kalkulator-marzy")({
	component: KalkulatorMarzyPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.strateg-cenowy.kalkulator-marzy",
			location.pathname,
		);
	},
});
